import lottie from "lottie-web";
import webfontloader from "webfontloader";

export function loading() {
  const isTopPage = location.pathname === "/" || location.pathname === "/index.html";
  const hasSeenAnimation = sessionStorage.getItem("hasSeenOpening") === "true";

  // アニメを再生しない場合（条件 2, 3）
  if (!isTopPage || hasSeenAnimation) {
    document.body.classList.add("loading-is-complete");

    // アニメーション用要素を非表示にする
    const opening = document.querySelector(".c-opening-animation");
    const loading = document.querySelector(".c-loading-wrapper");
    if (opening) opening.style.display = "none";
    if (loading) loading.style.display = "none";

    return; // 処理終了
  }

  // ✅ 初回訪問でTOPページ：アニメーションを再生
  sessionStorage.setItem("hasSeenOpening", "true");

  let hasStarted = false;

  lottie.loadAnimation({
    container: document.querySelector(".j-loading"),
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: `${themeVars.themeUri}/assets/json/loading.json`,
  });

  const runAnimations = () => {
    if (hasStarted) return;
    hasStarted = true;

    document.body.classList.add("content-load-is-complete");

    const logoAnimation = lottie.loadAnimation({
      container: document.querySelector(".j-logo-animation"),
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: `${themeVars.themeUri}/assets/json/logo-animation.json`,
    });

    logoAnimation.addEventListener("complete", () => {
      document.querySelector(".j-logo-animation")?.classList.add("logo-animation-is-complete");

      lottie.loadAnimation({
        container: document.querySelector(".j-opening-anime-bg"),
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: `${themeVars.themeUri}/assets/json/opening-anime-bg.json`,
      });

      lottie.loadAnimation({
        container: document.querySelector(".j-opening-anime-arrow-pc"),
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: `${themeVars.themeUri}/assets/json/opening-anime-arrow-pc.json`,
      });

      setTimeout(() => {
        document.body.classList.add("loading-is-complete");
      }, 1000);
    });
  };

  // フォントロード＆3秒のタイマー両方でトリガー
  webfontloader.load({
    custom: {
      families: [
        "TT Norms Regular",
        "dnp-shuei-gothic-gin-std",
        "TT-Travels-Next"
      ]
    },
    active: function () {
      runAnimations();
    }
  });

  setTimeout(() => {
    runAnimations();
  }, 1500);
}
